import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './mainpage.css';

import logo from '../static/hkfws-logo.png';

import Translate from "../translate/Translate";

class MainFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
        
        }
    }


    render() {
        return (
            <div className="footerContainer">
          <a onClick={()=>this.props.history.push('/disclaimer')}><Translate id="main.footer1"/></a><p></p>
          <div><Translate id="main.footer2"/></div>
        </div>
        )
    }
}

const mapStateToProps = state => ({
   
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
   
        },
        dispatch
    );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainFooter));